import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import rtlPlugin from "stylis-plugin-rtl";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { heIL } from '@mui/x-date-pickers/locales';
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { CacheProvider } from "@emotion/react";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const cacheRtl = createCache({
  key: "muirtl",
  // prefixer is the only stylis plugin by default, so when
  // overriding the plugins you need to include it explicitly
  // if you want to retain the auto-prefixing behavior.
  stylisPlugins: [prefixer, rtlPlugin]
});

const theme = createTheme({
  direction: 'rtl',
  palette:{
    primary:{
      main: '#1ABC9C',
      contrastText: '#fff'
    },
    secondary:{
      main: '#3498DB'
    }
  },
  typography:{
    fontFamily: 'Varela Round', 
  },
 
},
heIL,
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
       <CacheProvider value={cacheRtl}>

          <ThemeProvider theme={theme}>
          <App />
            </ThemeProvider>
            </CacheProvider>
    </React.StrictMode>
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
